import { render, staticRenderFns } from "./AddEditAircraftOld.vue?vue&type=template&id=b9be969e&scoped=true"
import script from "./AddEditAircraftOld.vue?vue&type=script&lang=js"
export * from "./AddEditAircraftOld.vue?vue&type=script&lang=js"
import style0 from "./AddEditAircraftOld.vue?vue&type=style&index=0&id=b9be969e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9be969e",
  null
  
)

export default component.exports